/**
 * MKPULSE homepage hero — product slide rotator.
 * One slide per product; autoplay with progress dots, arrows, swipe.
 */
(function () {
  const REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.dataset.mkHeroReady) return;
    const slides = Array.from(root.querySelectorAll('[data-mk-hero-slide]'));
    if (slides.length < 2) return;
    root.dataset.mkHeroReady = '1';

    const dots = Array.from(root.querySelectorAll('[data-mk-hero-dot]'));
    const prev = root.querySelector('[data-mk-hero-prev]');
    const next = root.querySelector('[data-mk-hero-next]');
    let index = Math.max(
      0,
      slides.findIndex((s) => s.classList.contains('is-active'))
    );
    let timer = null;
    let paused = false;
    const autoplay = Number(root.dataset.autoplay || 0);

    function go(i) {
      index = ((i % slides.length) + slides.length) % slides.length;
      slides.forEach((slide, n) => {
        const on = n === index;
        slide.classList.toggle('is-active', on);
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      dots.forEach((dot, n) => {
        const on = n === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      root.style.setProperty('--mk-hero-i', String(index));
      restart();
    }

    function restart() {
      clearInterval(timer);
      timer = null;
      root.classList.remove('is-playing');
      if (!autoplay || REDUCE || paused || document.hidden) return;
      // retrigger CSS progress animation
      void root.offsetWidth;
      root.classList.add('is-playing');
      timer = window.setInterval(() => go(index + 1), autoplay);
    }

    function pause() {
      paused = true;
      clearInterval(timer);
      timer = null;
      root.classList.remove('is-playing');
    }

    function resume() {
      paused = false;
      restart();
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', () => go(Number(dot.dataset.mkHeroDot) || 0));
    });
    if (prev) prev.addEventListener('click', () => go(index - 1));
    if (next) next.addEventListener('click', () => go(index + 1));

    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', resume);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', (e) => {
      if (!root.contains(e.relatedTarget)) resume();
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) pause();
      else resume();
    });

    // swipe
    let x0 = null;
    root.addEventListener(
      'pointerdown',
      (e) => {
        if (e.target.closest('a,button')) return;
        x0 = e.clientX;
      },
      { passive: true }
    );
    root.addEventListener(
      'pointerup',
      (e) => {
        if (x0 == null) return;
        const dx = e.clientX - x0;
        x0 = null;
        if (Math.abs(dx) < 48) return;
        go(index + (dx < 0 ? 1 : -1));
      },
      { passive: true }
    );

    root.style.setProperty('--mk-hero-ms', autoplay + 'ms');
    go(index);
  }

  function boot() {
    document.querySelectorAll('[data-mk-hero-slider]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
